import React from 'react';
import { useParams } from 'react-router-dom';
import { CTitle } from '../../components/Widget';
import { Collapse } from 'antd';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';
import icon1 from '@/assets/education/topic1000/phishing/icon1.svg';
import icon2 from '@/assets/education/topic1000/phishing/icon2.svg';
import icon3 from '@/assets/education/topic1000/phishing/icon3.svg';
import icon4 from '@/assets/education/topic1000/phishing/icon4.svg';
import icon5 from '@/assets/education/topic1000/phishing/icon5.svg';
import icon6 from '@/assets/education/topic1000/phishing/icon6.svg';
// import pic1 from '@/assets/education/topic1000/phishing/pic1.svg';
import bubble_bg from '@/assets/education/topic1000/phishing/bubble_bg.svg';
import panelData1 from '@/assets/education/topic1000/panelData1.png';
import panelData2 from '@/assets/education/topic1000/panelData2.png';
import panelData3 from '@/assets/education/topic1000/panelData3.png';
import panelData4 from '@/assets/education/topic1000/panelData4.jpg';
import panelData5 from '@/assets/education/topic1000/panelData5.png';
import panelData6 from '@/assets/education/topic1000/panelData6.jpg';
import useIntersectionObserver from '../../../../../../hooks/useIntersectionObserver';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import sectionBg1 from '../../../../../../assets/education/topic900/section1_1.png';

import ArrowImg from '../../../../../../assets/2025/arrow.gif';

const { Panel } = Collapse;

interface ISection3Props {
  settings: any;
}

const iconList = [icon1, icon2, icon3, icon4, icon5, icon6];

const picMap: any = {
  1: panelData1,
  2: panelData2,
  3: panelData3,
  4: panelData4,
  5: panelData5,
  6: panelData6,
};

const Section3: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const [state, setState] = React.useState({
    clickSlide: 2,
    state1: false,
    quiz: false,
  });
  const updateComponentState = useUpdateComponentState();

  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';

  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );

  const [checked, setChecked] = React.useState<any>([]);
  const [activeArr, setActiveArr] = React.useState([0, 1, 2, 3, 4, 5]);
  const [active, setActive] = React.useState<any>(0);

  const getArrayMin = (arr: any, value: any) => {
    const newArr = arr.filter((item: any) => item !== value);
    setActiveArr([...newArr]);
    if (!Array.isArray(newArr) || newArr.length === 0) return null;
    return Math.min(...newArr);
  };

  const changeTab = (key: any) => {
    if (!checked.includes(key)) {
      const newChecked = [...checked, key];
      setChecked(newChecked);
      if (newChecked.length >= 6) {
        updateComponentState(p_course, p_topic, ID, 'education-iws-section3-1');
      }
      const min = getArrayMin(activeArr, Number(key));
      setActive(min);
    }
  };

  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 0.1,
    rootMargin: '-50px',
  });

  const quiz = paragraphsSettings?.quiz;

  return (
    <div className="topic-section-3 topic-section-3-en">
      <CTitle title={paragraphsSettings.title} />
      <div className="dialogue-content" ref={targetRef}>
        {isVisible && (
          <div className="dialogue-text">
            <div className="dialogue-left text-focus-in">
              {paragraphsSettings.l1}
            </div>
            <div className="dialogue-right text-focus-in">
              {paragraphsSettings.l2}
            </div>
          </div>
        )}
        <img className="dialogue-bg" src={bubble_bg} alt="" />
      </div>

      <div className="t900_custom">
        <div className="example_content">
          <img className="example_content_img" src={sectionBg1} alt="" />
          <div className="example_content_title">
            <div>
              <span>{paragraphsSettings.descTitle}</span>
            </div>
          </div>
          <div className="example_content_con">
            {paragraphsSettings.overviewList?.map((item: string, i: string) => (
              <p key={i}>{item}</p>
            ))}
          </div>
          <div className="data_source">{paragraphsSettings.dataSource}</div>
          {paragraphsSettings.dataSourceList?.map((item: any, index: number) =>
            item.link ? (
              <a
                key={index}
                className="network_link"
                target="_blank"
                rel="noreferrer"
                href={item.link}
              >
                {item.label}
              </a>
            ) : (
              <div className="network_link" key={index}>
                {item.label}
              </div>
            )
          )}
        </div>
      </div>

      <div className="visit" id="education-iws-section3-1">
        <Collapse
          expandIcon={({ isActive }) =>
            isActive ? (
              <MinusOutlined
                style={{ color: '#FFFFFF', fontSize: '1.75rem' }}
              />
            ) : (
              <PlusOutlined style={{ color: '#FFFFFF', fontSize: '1.75rem' }} />
            )
          }
          accordion
          onChange={(key) => changeTab(key)}
        >
          {paragraphsSettings?.panelData.map((item: any, index: number) => (
            <Panel
              header={
                <>
                  {active === index && (
                    <img className="arrow-img" src={ArrowImg} alt="" />
                  )}
                  {item.header}
                  <img src={iconList[index]} alt="" />
                </>
              }
              key={index}
            >
              <div className="topic-section-3-img-con">
                <div className="left">
                  <p>{item.text}</p>
                </div>
                <div className="right">
                  <img src={picMap[item.id]} alt="" />
                </div>
              </div>
            </Panel>
          ))}
        </Collapse>
      </div>

      <div id="education-iws-section3-question" className="dialogue-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={() => {
            setState({ ...state, quiz: true });
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'education-iws-section3-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section3;
